import { render, staticRenderFns } from "./aptitudeType.vue?vue&type=template&id=514038fe&scoped=true"
import script from "./aptitudeType.vue?vue&type=script&lang=js"
export * from "./aptitudeType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514038fe",
  null
  
)

export default component.exports